import { gql } from "@apollo/client";

export const UPDATE_TRAINING = gql`
mutation UpdateTraining($input: UpdateTrainingInput!, $image: Upload) {
  updateTraining(
    input: $input,
    image: $image
  ) {
    id
    title
    description
    price
    category
    level
    format
    image
    provider
    duration
    startDate
    language
    certificate
    location
    instructor {
      name
      email
      specialization
    }
    requirements
    modules {
      title
      description
    }
    labs {
      title
      description
    }
    resources {
      name
      description
    }
  }
}
`;
